/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

    // Stili CSS per la modal
    const modalStyles = `
        .image-zoom-modal {
            display: none;
            position: fixed;
            z-index: 9999;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.9);
            opacity: 0;
            transition: opacity 0.3s ease;
        }

        .image-zoom-modal.active {
            display: flex;
            opacity: 1;
            align-items: center;
            justify-content: center;
        }

        .image-zoom-container {
            position: relative;
            width: 95vw;
            height: 95vh;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .image-zoom-container img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            transition: transform 0.2s ease;
            user-select: none;
            -webkit-user-select: none;
            transform-origin: center center;
        }

        .image-zoom-loader {
            position: absolute;
            width: 40px;
            height: 40px;
            border: 4px solid white;
            border-top: 4px solid transparent;
            border-radius: 50%;
            animation: spin 0.8s linear infinite;
            z-index: 10;
            display: none;
        }

        @keyframes spin {
            to { transform: rotate(360deg); }
        }

        .image-zoom-close {
            position: fixed;
            top: 20px;
            right: 20px;
            background: rgba(255, 255, 255, 0.2);
            border: none;
            color: white;
            font-size: 24px;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            cursor: pointer;
            z-index: 10000;
            display: flex;
            align-items: center;
            justify-content: center;
            backdrop-filter: blur(10px);
            transition: background-color 0.2s ease;
        }

        .image-zoom-close:hover {
            background: rgba(255, 255, 255, 0.3);
        }

        .image-zoom-nav {
            position: fixed;
            top: 50%;
            transform: translateY(-50%);
            background: rgba(255, 255, 255, 0.2);
            border: none;
            color: white;
            font-size: 20px;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            cursor: pointer;
            z-index: 10000;
            display: flex;
            align-items: center;
            justify-content: center;
            backdrop-filter: blur(10px);
            transition: all 0.2s ease;
        }

        .image-zoom-nav:hover {
            background: rgba(255, 255, 255, 0.3);
            transform: translateY(-50%) scale(1.1);
        }

        .image-zoom-nav.prev {
            left: 20px;
        }

        .image-zoom-nav.next {
            right: 20px;
        }

        @media (max-width: 768px) {
            .image-zoom-nav {
                width: 40px;
                height: 40px;
                font-size: 16px;
            }

            .image-zoom-nav.prev {
                left: 10px;
            }

            .image-zoom-nav.next {
                right: 10px;
            }

            .image-zoom-close {
                top: 10px;
                right: 10px;
                width: 35px;
                height: 35px;
                font-size: 20px;
            }
        }
    `;

    let modal;
    let currentImageIndex = 0;
    let images = [];
    let scale = 1;
    let translateY = 0;

    function addStyles() {
        const styleSheet = document.createElement('style');
        styleSheet.textContent = modalStyles;
        document.head.appendChild(styleSheet);
    }

    function createModal() {
        const modal = document.createElement('div');
        modal.className = 'image-zoom-modal';
        modal.innerHTML = `
            <button class="image-zoom-close" aria-label="Chiudi">&times;</button>
            <button class="image-zoom-nav prev" aria-label="Immagine precedente">&#8249;</button>
            <button class="image-zoom-nav next" aria-label="Immagine successiva">&#8250;</button>
            <div class="image-zoom-container">
                <div class="image-zoom-loader"></div>
                <img src="" alt="" />
            </div>
        `;
        document.body.appendChild(modal);
        return modal;
    }

    function initImageZoom() {
        const pathMatches = location.pathname.includes('/lookbook');
        const urlParams = new URLSearchParams(location.search);
        const viewParam = urlParams.get('view') || '';
        const viewMatches = viewParam.includes('lookbook');
        if (!pathMatches && !viewMatches) return;

        addStyles();
        modal = createModal();

        const modalImg = modal.querySelector('.image-zoom-container img');
        const loader = modal.querySelector('.image-zoom-loader');
        const closeBtn = modal.querySelector('.image-zoom-close');
        const prevBtn = modal.querySelector('.image-zoom-nav.prev');
        const nextBtn = modal.querySelector('.image-zoom-nav.next');

        function findTextColumnsImages() {
            const textColumnSections = document.querySelectorAll('.section-columns[data-section-type="columns"]');
            const textColumnImages = [];

            textColumnSections.forEach(section => {
                const columnImages = section.querySelectorAll('.column__image img');
                columnImages.forEach(img => {
                    const highResUrl = img.src.replace(/(\?.*)?$/, '?v=' + (img.src.match(/v=(\d+)/) ? img.src.match(/v=(\d+)/)[1] : Date.now()));
                    textColumnImages.push({
                        element: img,
                        url: highResUrl,
                        alt: img.alt || 'Lookbook Image'
                    });
                });
            });

            return textColumnImages;
        }

        function resetTransform() {
            scale = 1;
            translateY = 0;
            modalImg.style.transform = 'scale(1) translateY(0px)';
        }

        function setTransform() {
            modalImg.style.transform = `scale(${scale}) translateY(${translateY}px)`;
        }

        function showImage(index) {
            if (index < 0 || index >= images.length) return;

            currentImageIndex = index;
            loader.style.display = 'block';
            modalImg.style.display = 'none';

            modalImg.onload = () => {
                loader.style.display = 'none';
                modalImg.style.display = 'block';
                resetTransform();
            };

            modalImg.src = images[index].url;
            modalImg.alt = images[index].alt;

            prevBtn.style.display = images.length > 1 ? 'flex' : 'none';
            nextBtn.style.display = images.length > 1 ? 'flex' : 'none';
        }

        closeBtn.addEventListener('click', () => {
            modal.classList.remove('active');
            document.body.style.overflow = '';
        });

        prevBtn.addEventListener('click', () => {
            const newIndex = currentImageIndex > 0 ? currentImageIndex - 1 : images.length - 1;
            showImage(newIndex);
        });

        nextBtn.addEventListener('click', () => {
            const newIndex = currentImageIndex < images.length - 1 ? currentImageIndex + 1 : 0;
            showImage(newIndex);
        });

        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                modal.classList.remove('active');
                document.body.style.overflow = '';
            }
        });

        document.addEventListener('keydown', (e) => {
            if (!modal.classList.contains('active')) return;

            switch(e.key) {
                case 'Escape':
                    modal.classList.remove('active');
                    document.body.style.overflow = '';
                    break;
                case 'ArrowLeft':
                    prevBtn.click();
                    break;
                case 'ArrowRight':
                    nextBtn.click();
                    break;
            }
        });

        modalImg.addEventListener('wheel', (e) => {
            e.preventDefault();

            if (e.ctrlKey || e.metaKey) {
                const delta = e.deltaY > 0 ? 0.9 : 1.1;
                const newScale = scale * delta;

                if (newScale >= 1 && newScale <= 3) {
                    scale = newScale;
                    translateY = 0;
                    setTransform();
                }
            } else if (scale > 1) {
                const scrollAmount = 50;
                const maxTranslate = (modalImg.offsetHeight * (scale - 1)) / 2;

                if (e.deltaY > 0) {
                    translateY = Math.max(translateY - scrollAmount, -maxTranslate);
                } else {
                    translateY = Math.min(translateY + scrollAmount, maxTranslate);
                }
                setTransform();
            }
        });

        let initialDistance = 0;
        let initialScale = 1;
        let touchStartY = 0;
        let initialTranslateY = 0;

        modalImg.addEventListener('touchstart', (e) => {
            if (e.touches.length === 1 && scale > 1) {
                touchStartY = e.touches[0].clientY;
                initialTranslateY = translateY;
            } else if (e.touches.length === 2) {
                e.preventDefault();
                initialDistance = Math.hypot(
                    e.touches[0].clientX - e.touches[1].clientX,
                    e.touches[0].clientY - e.touches[1].clientY
                );
                initialScale = scale;
            }
        });

        modalImg.addEventListener('touchmove', (e) => {
            if (e.touches.length === 1 && scale > 1) {
                e.preventDefault();
                const deltaY = e.touches[0].clientY - touchStartY;
                const maxTranslate = (modalImg.offsetHeight * (scale - 1)) / 2;

                translateY = Math.max(Math.min(initialTranslateY + deltaY, maxTranslate), -maxTranslate);
                setTransform();
            } else if (e.touches.length === 2) {
                e.preventDefault();
                const distance = Math.hypot(
                    e.touches[0].clientX - e.touches[1].clientX,
                    e.touches[0].clientY - e.touches[1].clientY
                );
                const newScale = initialScale * (distance / initialDistance);

                if (newScale >= 1 && newScale <= 3) {
                    scale = newScale;
                    translateY = 0;
                    setTransform();
                }
            }
        });

        function attachImageListeners() {
            images.forEach((imageData, index) => {
                imageData.element.style.cursor = 'pointer';
                imageData.element.addEventListener('click', (e) => {
                    e.preventDefault();
                    currentImageIndex = index;
                    showImage(index);
                    modal.classList.add('active');
                    document.body.style.overflow = 'hidden';
                });
            });
        }

        setTimeout(() => {
            images = findTextColumnsImages();
            attachImageListeners();
        }, 300);

        const observer = new MutationObserver(() => {
            clearTimeout(observer.timeout);
            observer.timeout = setTimeout(() => {
                images = findTextColumnsImages();
                attachImageListeners();
            }, 100);
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initImageZoom);
    } else {
        initImageZoom();
    }


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
